var AngularSetup = require("../common/utils/angular-setup");

require("../common/branding/index.scss");
require("../common/index.scss");
require("./index.scss");

window.$ = window.jQuery = require("jquery");
window.Tether = require("tether");
require("bootstrap");

var SetupAnalytics = require("../common/analytics");

var setup = (module.exports = AngularSetup("account"));

setup
  .module(require("../common/deps").name)
  .module(require("../common/directives").name);

setup
  .state("account", {
    url: "/account",
    abstract: true,
    template: require("./index.pug"),
    data: {
      authenticate: true
    }
  })
  .state("account.profile", {
    url: "",
    template: require("./profile/index.pug"),
    controller: require("./profile/"),
    controllerAs: "vm"
  })
  .state("account.preferences", {
    url: "/preferences",
    template: require("./preferences/index.pug"),
    controller: require("./preferences/"),
    controllerAs: "vm",
    data: {
      claims: [{ type: "gdpr_questions_completed", value: null, state: "account.profile" }]
    }
  })
  .state("account.messages", {
    url: "/messages",
    template: require("./messages/index.pug"),
    controller: require("./messages/"),
    controllerAs: "vm",
    data: {
      claims: [{ type: "gdpr_questions_completed", value: null, state: "account.profile" }]
    }
  })
  .state("account.notifications", {
    url: "/notifications",
    template: require("./notifications/index.pug"),
    controller: require("./notifications/"),
    controllerAs: "vm",
    data: {
      claims: [{ type: "gdpr_questions_completed", value: null, state: "account.profile" }]
    }
  })
  .state("account.fundraisingprofile", {
    url: "/fundraisingprofile/:id",
    template: require("./fundraisingprofile/index.pug"),
    controller: require("./fundraisingprofile/"),
    controllerAs: "vm",
    data: {
      claims: [{ type: "gdpr_questions_completed", value: null, state: "account.profile" }]
    }
  })
  .state("account.reports", {
    url: "/reports",
    template: require("./reports/index.pug"),
    controller: require("./reports/"),
    controllerAs: "vm",
    data: {
      claims: [{ type: "gdpr_questions_completed", value: null, state: "account.profile" }]
    }
  });

setup.auth(require("./auth"));

// init app module
var app = setup.done();

SetupAnalytics(app);
